/*
 * c-cart — カート（ページ・ドロワー）の追加機能（#3 追加・2026-10-05）
 * main-cart.liquid・cart-drawer.liquid から読み込む。theme.js は変更しない。
 *
 * 1. バリエーション変更（snippets/cart-item.liquid の select[data-c-cart-variant]）
 *    Shopify は明細のバリエーションを直接変えられないので、
 *    先に「新しいバリエーション（同じ数量・同じ properties）」を /cart/add.js で入れ、
 *    成功したら元の行を /cart/update.js で 0 にして `cart:build` で描き直す（追加に失敗したら何も消さない）。
 *    この商品用のリボン行（properties[対象商品] が一致）も新しい名前で入れ直す。
 * 1b. 「削除」リンク（ドロワーは theme.css が隠していたものを c-cart.css で出す）は、ページ移動せず数量欄を 0 にする経路で消す
 * 1c. 数量変更のあと、リボンの数を対象商品の数にそろえる（対象を消したらリボンも消える）
 * 2. まとめ欄の「送料」行（snippets/c-cart-summary.liquid）
 *    まとめ欄は theme.js の描き直し対象外なので、明細（.cart__items[data-cart-subtotal]）が差し替わったら書き換える。
 */
(function () {
  if (window.cCart) return;
  window.cCart = true;

  var RIBBON_KEY = '対象商品';
  var busy = false;

  function routes() {
    return (window.theme && theme.routes) || {};
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status) throw json;
        return json;
      });
    });
  }

  function getCart() {
    return fetch((routes().cart || '/cart.js') + '?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function lineItem(line, variantId, properties) {
    var item = { id: variantId, quantity: line.quantity };
    if (properties && Object.keys(properties).length) item.properties = properties;
    var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
    if (plan) item.selling_plan = plan.id;
    return item;
  }

  // ---- 1. バリエーション変更 ----
  document.addEventListener('change', function (evt) {
    var select = evt.target;
    if (!select.matches || !select.matches('[data-c-cart-variant]')) return;
    if (busy) return;

    var key = select.getAttribute('data-key');
    var newId = parseInt(select.value, 10);
    var oldTarget = select.getAttribute('data-c-cart-target') || '';
    var ribbonId = parseInt(select.getAttribute('data-c-cart-ribbon'), 10) || 0;
    var newTitle = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text.trim() : '';
    var row = select.closest('.cart__item');
    // 見た目の文字（select に重ねた枠）を先に新しい名前へ。失敗しても最後の cart:build で描き直される
    var label = select.parentNode && select.parentNode.querySelector('[data-c-cart-variant-label]');
    if (label && newTitle) label.textContent = newTitle;

    busy = true;
    select.disabled = true;
    if (row) row.classList.add('is-loading');

    getCart()
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!line) throw new Error('line not found');
        if (line.variant_id === newId) return null;

        var newTarget = line.product_title + ' / ' + newTitle;
        var items = [lineItem(line, newId, line.properties)];
        var updates = {};
        updates[key] = 0;

        if (ribbonId) {
          cart.items.forEach(function (i) {
            if (i.variant_id === ribbonId && i.properties && i.properties[RIBBON_KEY] === oldTarget) {
              var props = Object.assign({}, i.properties);
              props[RIBBON_KEY] = newTarget;
              items.push(lineItem(i, ribbonId, props));
              updates[i.key] = 0;
            }
          });
        }

        return post(routes().cartAdd || '/cart/add.js', { items: items })
          .then(function () { return post('/cart/update.js', { updates: updates }); });
      })
      .catch(function (error) {
        console.warn('[c-cart] variant change', error);
        var message = error && (error.description || error.message);
        window.alert(typeof message === 'string' && message ? message : '変更できませんでした。時間をおいてもう一度お試しください。');
      })
      .then(function () {
        busy = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
        runPendingSync();
      });
  });

  // ---- 1b. 「削除」（2026-10-12） ----
  // 削除リンクは /cart/change?…quantity=0 への普通のリンクで、押すとカートページへ移って（読み直して）しまう。
  // ドロワーとカートページの両方で、数量欄を 0 にして change を出し、theme.js の数量変更（−ボタンと同じ経路）で消して描き直させる。
  // こうすると cart:updated が出るので、下の 1c（リボンの数をそろえる）も動く
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest && evt.target.closest('[data-products] .cart__remove a');
    if (!link) return;
    var row = link.closest('.cart__item');
    var input = row && row.querySelector('.js-qty__num');
    if (!input) return;
    evt.preventDefault();
    // QtySelector は min 属性（"0"・文字列）で下限をそろえるので、quantityChanged の `!qty` に掛からず 0 で送られる
    // （theme.js 3100 前後 _change・1825 前後 quantityChanged。2026-10-12 に PC/SP で削除・空表示まで確認）
    input.value = '0';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---- 1c. リボンの数を対象商品の数にそろえる（2026-10-12・本人指示） ----
  // リボンは別の明細なので、対象商品を消す・減らすとリボン代だけが残っていた。
  // theme.js は数量変更のあと cart:updated（detail.cart＝変更後のカート）を出すので、それを見て
  // 「リボンの数 ≦ 対象商品の数」になるようリボン行を減らす（0 なら消す）。増やした時は増やさない（全部に付けたいとは限らない）
  // 対象の判定は properties[対象商品] と「商品名 / バリエーション名」（cart.js の既定バリエーションは variant_title が null → Default Title）または商品名だけ
  // カートページ（#CartPageForm）で空になったら読み直す。テーマは空のフォーム（小計 ¥0）を残すので、
  // サーバー側の「カートは空です」の表示に切り替える（ドロワーは theme.js が is-empty で空表示にする）
  function reloadIfEmptyPage(cart) {
    if (cart && cart.item_count === 0 && document.getElementById('CartPageForm')) window.location.reload();
  }

  // 割り当て: 商品ごとの合計数を共通の上限にし、「商品名 / バリエーション名」のリボンを先に、「商品名だけ」のリボンを後に割り当てる
  // （両方の形式が混ざっても合計で対象商品の数を超えない）
  function ribbonUpdates(cart) {
    var byVariant = {}; // 「商品名 / バリエーション名」→ 数
    var byProduct = {}; // 商品名 → 数（その商品の全バリエーションの合計・共通の上限）
    var productOf = {}; // 「商品名 / バリエーション名」→ 商品名
    cart.items.forEach(function (i) {
      if (i.properties && i.properties[RIBBON_KEY]) return;
      var full = i.product_title + ' / ' + (i.variant_title || 'Default Title');
      byVariant[full] = (byVariant[full] || 0) + i.quantity;
      byProduct[i.product_title] = (byProduct[i.product_title] || 0) + i.quantity;
      productOf[full] = i.product_title;
    });

    var ribbons = cart.items.filter(function (i) { return i.properties && i.properties[RIBBON_KEY]; });
    var specific = ribbons.filter(function (i) { return byVariant[i.properties[RIBBON_KEY]] !== undefined; });
    var rest = ribbons.filter(function (i) { return byVariant[i.properties[RIBBON_KEY]] === undefined; });

    var updates = {};
    var changed = false;
    function settle(line, keep) {
      if (keep !== line.quantity) {
        updates[line.key] = keep;
        changed = true;
      }
    }
    specific.forEach(function (i) {
      var t = i.properties[RIBBON_KEY];
      var p = productOf[t];
      var keep = Math.min(i.quantity, byVariant[t], byProduct[p] || 0);
      byVariant[t] -= keep;
      byProduct[p] -= keep;
      settle(i, keep);
    });
    rest.forEach(function (i) {
      var p = i.properties[RIBBON_KEY];
      var keep = Math.min(i.quantity, byProduct[p] || 0); // 商品名だけの対象。見つからなければ 0（消す）
      if (byProduct[p]) byProduct[p] -= keep;
      settle(i, keep);
    });
    return changed ? updates : null;
  }

  // 同期中・バリエーション変更中に来た数量変更は捨てずに印を付け、終わったら最新のカートでもう一度そろえる
  var pendingSync = false;

  function syncRibbons(cart) {
    if (!cart || !cart.items) return;
    if (busy) { pendingSync = true; return; }
    reloadIfEmptyPage(cart);
    var updates = ribbonUpdates(cart);
    if (!updates) return;

    busy = true;
    post('/cart/update.js', { updates: updates })
      .then(reloadIfEmptyPage)
      .catch(function (error) {
        console.warn('[c-cart] ribbon sync', error);
        window.alert('リボンの数を商品に合わせられませんでした。カートのリボンの数をご確認ください。');
      })
      .then(function () {
        busy = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
        runPendingSync();
      });
  }

  function runPendingSync() {
    if (!pendingSync || busy) return;
    pendingSync = false;
    getCart().then(syncRibbons).catch(function (error) { console.warn('[c-cart] ribbon sync', error); });
  }

  document.addEventListener('cart:updated', function (evt) {
    syncRibbons(evt.detail && evt.detail.cart);
  });

  // ---- 2. 送料行 ----
  function syncShipping() {
    var items = document.querySelector('.cart__items[data-cart-subtotal]');
    if (!items) return;
    var subtotal = parseInt(items.getAttribute('data-cart-subtotal'), 10) || 0;
    document.querySelectorAll('[data-c-cart-shipping-row]').forEach(function (row) {
      var free = subtotal >= (parseInt(row.getAttribute('data-threshold'), 10) || 0);
      var yes = row.querySelector('[data-c-cart-shipping-free]');
      var no = row.querySelector('[data-c-cart-shipping-later]');
      if (yes) yes.hidden = !free;
      if (no) no.hidden = free;
    });
  }

  function watch() {
    document.querySelectorAll('[data-products]').forEach(function (products) {
      if (products.__cCartWatched) return;
      products.__cCartWatched = true;
      new MutationObserver(syncShipping).observe(products, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
